import { paths } from "config/paths";
import { useWebRouter } from "~utils/next-router/use-web-router";
import { FC, ReactNode } from "react";
import { useGetCurrentAccountCache } from "~auth/queries/useGetCurrentAccount";
import { useGetCurrentUserCache } from "~auth/queries/useGetCurrentUser";
import { GET_DATASET_ACCESS_METHOD_TYPE } from "~auth/types/__generated/gql/graphql";
import { useGetCurrentDatasetAccessMethod } from "~dataset-view/queries/useGetDatasetAccessMethod";
import { MangoLogoLoadingBackdrop } from "~ui-components/components/atoms/mango-logo-loading-backdrop";

export const DatasetGuard: FC<{ children: ReactNode }> = ({ children }) => {
	const router = useWebRouter();
	const { isLoading: isUserLoading, data: user } = useGetCurrentUserCache();
	const { isLoading: isAccountLoading } = useGetCurrentAccountCache();
	const { isLoading: isDatasetAccessMethodLoading, data: datasetAccessMethod } =
		useGetCurrentDatasetAccessMethod();

	if (
		isUserLoading ||
		isAccountLoading ||
		isDatasetAccessMethodLoading ||
		!router.isReady
	)
		return <MangoLogoLoadingBackdrop />;

	if (datasetAccessMethod) {
		if (datasetAccessMethod.type === GET_DATASET_ACCESS_METHOD_TYPE.NOT_FOUND) {
			void router.replace(paths.notFound);
			return <MangoLogoLoadingBackdrop />;
		} else {
			return children;
		}
	}

	if (user) {
		void router.replace(paths.unauthorized);
	} else {
		void router.replace(paths.accountName.signIn(router._query.accountName));
	}
	return <MangoLogoLoadingBackdrop />;
};
